"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ModuleItemFilter_vue_1 = __importDefault(require("./ModuleItemFilter.vue"));
const GameModule_1 = require("@/common/cards/GameModule");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
function ceoCardNames(module) {
    return (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byModule)(module))
        .filter((0, ClientCardManifest_1.byType)(CardType_1.CardType.CEO))
        .map(utils_1.toName);
}
const interim = GameModule_1.GAME_MODULES.map((module) => [module, []]);
const ALL_CARDS_BY_MODULE = Object.fromEntries(interim);
(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CEO)).forEach((card) => {
    ALL_CARDS_BY_MODULE[card.module].push(card.name);
});
GameModule_1.GAME_MODULES.forEach((module) => ALL_CARDS_BY_MODULE[module].sort());
const GROUPS = GameModule_1.GAME_MODULES.map((module) => ({ key: module, label: GameModule_1.MODULE_NAMES[module] }));
exports.default = (0, vue_1.defineComponent)({
    name: 'CeosFilter',
    components: { ModuleItemFilter: ModuleItemFilter_vue_1.default },
    emits: ['ceo-list-changed', 'close'],
    props: {
        expansions: { type: Object, required: true },
        selected: { type: Array, required: true },
    },
    data() {
        const initialSelected = this.selected.length > 0 ? [...this.selected] :
            ceoCardNames('base').concat(...GameModule_1.EXPANSIONS.map((expansion) => this.expansions[expansion] ? ceoCardNames(expansion) : []));
        return { initialSelected };
    },
    computed: {
        GROUPS() {
            return GROUPS;
        },
        ALL_CARDS_BY_MODULE() {
            return ALL_CARDS_BY_MODULE;
        },
    },
    methods: {
        compatibility(name) {
            return (0, ClientCardManifest_1.getCard)(name)?.compatibility ?? [];
        },
    },
});
